(function () {
  function plural(n, one, few, many) {
    if (n === 1) return one;
    var d = n % 10, t = n % 100;
    return d >= 2 && d <= 4 && (t < 12 || t > 14) ? few : many;
  }
  function track(name, data) {
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }
  function init(root) {
    if (root.__eyk) return; root.__eyk = true;
    var sid = root.getAttribute('data-section');
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var grid = root.querySelector('[data-eyk-grid]');
    if (!grid) return;
    var countEl = root.querySelector('[data-eyk-count]');
    var emptyEl = root.querySelector('[data-eyk-empty]');
    var moreEl = root.querySelector('[data-eyk-more]');
    var moreBtn = root.querySelector('[data-eyk-more-btn]');
    var moreTxt = root.querySelector('[data-eyk-more-txt]');
    var moreBar = root.querySelector('[data-eyk-more-bar]');
    var nextUrl = moreEl ? moreEl.getAttribute('data-next') : '';
    var params = new URLSearchParams(location.search);
    var state = { shape: params.get('bryla') || '', fabric: params.get('tkanina') || '' };
    var storeKey = 'eyk:' + location.pathname + '|' + (params.get('sort_by') || '') + '|' + location.search.replace(/[?&](bryla|tkanina|page)=[^&]*/g, '');
    var loading = null;

    function items() { return grid.querySelectorAll('.eyk-item'); }

    function progress() {
      if (!moreEl) return;
      var n = items().length;
      if (moreTxt) moreTxt.textContent = 'Wyświetlono ' + n + ' z ' + total;
      if (moreBar) moreBar.style.width = (total ? Math.min(100, Math.round(n / total * 100)) : 100) + '%';
      var filtering = !!(state.shape || state.fabric);
      moreEl.hidden = !nextUrl || filtering;
    }

    function apply() {
      var n = 0;
      items().forEach(function (li) {
        var ok = (!state.shape || li.getAttribute('data-shape') === state.shape) && (!state.fabric || li.getAttribute('data-fabric') === state.fabric);
        li.hidden = !ok;
        if (ok) n++;
      });
      var filtering = !!(state.shape || state.fabric);
      var cmp = grid.querySelector('.eyk-cmp');
      if (cmp) cmp.hidden = filtering;
      root.querySelectorAll('[data-eyk-shape]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-eyk-shape') === state.shape)); });
      root.querySelectorAll('[data-eyk-fabric]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-eyk-fabric') === state.fabric)); });
      var shown = filtering ? n : total;
      if (countEl) countEl.textContent = shown + ' ' + plural(shown, 'produkt', 'produkty', 'produktów');
      if (emptyEl) emptyEl.hidden = n > 0;
      progress();
      try {
        var u = new URL(location.href);
        if (state.shape) u.searchParams.set('bryla', state.shape); else u.searchParams.delete('bryla');
        if (state.fabric) u.searchParams.set('tkanina', state.fabric); else u.searchParams.delete('tkanina');
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }

    function loadNext() {
      if (!nextUrl) return Promise.resolve();
      if (loading) return loading;
      var url = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
      if (moreBtn) { moreBtn.setAttribute('aria-busy', 'true'); moreBtn.disabled = true; }
      loading = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var frag = document.createDocumentFragment();
        doc.querySelectorAll('[data-eyk-grid] .eyk-item').forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
        grid.appendChild(frag);
        var nm = doc.querySelector('[data-eyk-more]');
        nextUrl = nm ? nm.getAttribute('data-next') : '';
        var pages = (parseInt(sessionStorage.getItem(storeKey), 10) || 1) + 1;
        try { sessionStorage.setItem(storeKey, String(pages)); } catch (e) {}
      }).catch(function () { nextUrl = nextUrl; }).then(function () {
        loading = null;
        if (moreBtn) { moreBtn.removeAttribute('aria-busy'); moreBtn.disabled = false; }
        apply();
      });
      return loading;
    }

    function loadAll() {
      if (!nextUrl) return Promise.resolve();
      return loadNext().then(function () { return nextUrl ? loadAll() : null; });
    }

    function setFilter(key, val) {
      state[key] = state[key] === val ? '' : val;
      if (key === 'shape' && val === '') state.shape = '';
      track('eyk_filtr', { eyk_typ: key, eyk_wartosc: state[key] || 'wszystko' });
      if ((state.shape || state.fabric) && nextUrl) { loadAll().then(apply); } else { apply(); }
    }

    root.querySelectorAll('[data-eyk-shape]').forEach(function (b) {
      b.addEventListener('click', function () { var v = b.getAttribute('data-eyk-shape'); if (v === '') { state.shape = ''; apply(); return; } setFilter('shape', v); });
    });
    root.querySelectorAll('[data-eyk-fabric]').forEach(function (b) {
      b.addEventListener('click', function () { setFilter('fabric', b.getAttribute('data-eyk-fabric')); });
    });
    root.querySelectorAll('[data-eyk-clear]').forEach(function (b) {
      b.addEventListener('click', function () { state.shape = ''; state.fabric = ''; apply(); });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { track('eyk_pokaz_wiecej'); loadNext(); });

    var sort = root.querySelector('[data-eyk-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
    });

    var dlg = root.querySelector('[data-eyk-dlg]');
    root.querySelectorAll('[data-eyk-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (dlg && dlg.showModal) dlg.showModal(); else if (dlg) dlg.setAttribute('open', ''); });
    });
    if (dlg) {
      dlg.querySelectorAll('[data-eyk-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    }

    var cmp = root.querySelector('[data-eyk-cmp]');
    if (cmp) {
      var its = cmp.querySelectorAll('[data-eyk-cmp-it]');
      var tEl = cmp.querySelector('[data-eyk-cmp-title]'), pEl = cmp.querySelector('[data-eyk-cmp-price]'), dEl = cmp.querySelector('[data-eyk-cmp-dims]'), cta = cmp.querySelector('[data-eyk-cmp-cta]');
      var counts = {};
      root.querySelectorAll('[data-eyk-shape]').forEach(function (b) { counts[b.getAttribute('data-eyk-shape')] = b.getAttribute('data-count'); });
      function pick(it) {
        its.forEach(function (x) { x.setAttribute('aria-pressed', String(x === it)); });
        tEl.textContent = it.getAttribute('data-title');
        pEl.textContent = it.getAttribute('data-price');
        dEl.textContent = it.getAttribute('data-dims');
        var f = it.getAttribute('data-filter');
        cta.setAttribute('data-filter', f);
        cta.textContent = it.getAttribute('data-cta') + (counts[f] ? ' (' + counts[f] + ')' : '');
      }
      its.forEach(function (it) { it.addEventListener('click', function () { pick(it); track('eyk_porownaj', { eyk_bryla: it.getAttribute('data-title') }); }); });
      if (its.length) pick(its[0]);
      cta.addEventListener('click', function () {
        var f = cta.getAttribute('data-filter');
        track('eyk_porownaj_filtr', { eyk_bryla: f });
        state.shape = '';
        setFilter('shape', f);
        var bar = root.querySelector('.eyk-bar');
        if (bar) bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var saved = parseInt(sessionStorage.getItem(storeKey), 10) || 1;
    var restore = Promise.resolve();
    if (saved > 1 && nextUrl && !params.get('page')) {
      try { sessionStorage.setItem(storeKey, '1'); } catch (e) {}
      for (var i = 1; i < saved; i++) restore = restore.then(loadNext);
    }
    restore.then(function () {
      if ((state.shape || state.fabric) && nextUrl) return loadAll();
    }).then(apply);
  }
  function boot() { document.querySelectorAll('[data-eyk]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
